<template>
    <div>
        <div v-if="mobileState && swiper" class="t-swipper">
            <swiper :options="swiperOption_mobile" ref="teacher-promo">    
                <swiper-slide v-for="(teacher, index) in items" :key="'teacher-'+index" class="t-work-area__cell_promo">
                    <h2>{{ text.title }}</h2>
                    <cmp-teacher :data="teacher"></cmp-teacher>
                </swiper-slide>
            </swiper>
            <div class="t-swipper__pagination" :class="[ paginatorClass,  {'_flex-start':(items.length > 5)}]"></div>
        </div>
        <template v-else>
            <div v-for="(teacher, index) in items" :key="'teacher-'+index" class="t-work-area__cell_promo">
                <h2>{{ text.title }}</h2>
                <cmp-teacher :data="teacher"></cmp-teacher>
            </div>
        </template>
        <div class="t-promo__btn" v-if="hasAuth">
            <div class="t-btn t-btn_full" @click="modalDialogType_bannerAdd()">
                <span>
                    {{ text.promoBtn }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    import Teacher from './Teacher.vue'

    export default {
        props: {
            text: { 
                type: Object,
                default: function () {
                    return {
                        title: 'Рекомендуемый учитель',
                        promoBtn: 'Заказать рекламу'
                    }
                }
            },
            swiper: { 
                type: Boolean,
                default: true
            },
            items: {
                type: Array,
            }
        },
        data() {
            return {
                paginatorClass: 'js-pagination__teachers-' + this.$route.name
            }
        },        
        components: {
            'cmp-teacher': Teacher,
        },
        computed: {
            ...mapGetters(['mobileState']),
            ...mapGetters('standartObjects', ['swiperOption']),
            ...mapGetters('profile', ['hasAuth']),
            swiperOption_mobile(){ 
                return this.swiperOption('.'+this.paginatorClass)
            },
        },
        methods: {
            ...mapActions('modal', ['modalDialogType_bannerAdd']),
        },
        // created() {
        //     this.modalDialogType_bannerAdd();
        // },
    }
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// src/vue_components/PromoTeachers.vue